import { ref, computed } from 'vue';
import helpRegistry, { HelpActionItem, HelpContext } from '@/help/helpRegistry';
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { useLayoutStore } from '@/store/layout/layoutStore';

const isOpen = ref(false);
const currentKey = ref<string | null>(null);

const currentContext = computed<HelpContext | null>(() => {
  if (!currentKey.value) return null;
  return helpRegistry[currentKey.value] ?? null;
});

export function useHelp() {
  function openHelp() {
    const contextKey = useLayoutStore().pageContext;

    if (!helpRegistry[contextKey]) {
      console.warn(`[useHelp] Unknown help context: ${contextKey}`);
      return;
    }
    currentKey.value = contextKey;
    isOpen.value = true;
  }

  function closeHelp() {
    isOpen.value = false;
  }

  async function trigger(item: HelpActionItem) {
    if (item.action === 'showDriver') {
      const steps = item.steps ?? [];
      try {
        const d = driver({
          allowClose: true,
          showProgress: true,
          animate: true,
          steps,
        });
        d.drive();
      } catch (err) {
        console.error('[useHelp] Failed to start driver.js', err);
      }
      isOpen.value = false;
    } else if (item.action === 'showInfo') {
      if (item.content) {
        alert(item.content);
      }
    }
  }

  return {
    isOpen,
    currentContext,
    openHelp,
    closeHelp,
    trigger,
  };
}
